import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import markSelectOptions from './markSelectOptions'

const OPTION_ID = 'option_id'
const NEW_OPTION_CONTENT = 'new_option_content'
const ALLOW_OPTION_CREATION = 'allow_option_creation'
const IS_NEW = '__isNew__'

const typedOption = content => ({ value: content, label: content, [IS_NEW]: true })
const formatCreateLabel = inputValue => `Créer « ${inputValue} »`

const SelectMarkField = ({ mark, readonly, onChange }) => {
  const options = markSelectOptions(mark.question.options)
  const newContent = mark[NEW_OPTION_CONTENT]
  const selected = options.find(option => option.value === mark[OPTION_ID]) || null
  const value = newContent ? typedOption(newContent) : selected

  const handleChange = useCallback(option => {
    if (option?.[IS_NEW]) {
      onChange({ [OPTION_ID]: null, [NEW_OPTION_CONTENT]: option.value })
      return
    }
    onChange({ [OPTION_ID]: option ? option.value : null, [NEW_OPTION_CONTENT]: null })
  }, [onChange])

  return (
    <Select
      className="tw:lg:w-1/2"
      creatable={Boolean(mark.question[ALLOW_OPTION_CREATION]) && !readonly}
      error={false}
      formatCreateLabel={formatCreateLabel}
      isClearable={!mark.question.mandatory}
      isDisabled={readonly}
      options={options}
      value={value}
      onChange={handleChange}
    />
  )
}

SelectMarkField.propTypes = {
  mark: PropTypes.shape({
    [NEW_OPTION_CONTENT]: PropTypes.string,
    [OPTION_ID]: PropTypes.number,
    question: PropTypes.shape({
      [ALLOW_OPTION_CREATION]: PropTypes.bool,
      mandatory: PropTypes.bool,
      options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        content: PropTypes.string,
        discarded: PropTypes.bool
      }))
    })
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readonly: PropTypes.bool
}

SelectMarkField.defaultProps = {
  readonly: false
}

export default SelectMarkField
